export const ADMIN_ROUTE = "/admin";
